import SubNavigation from "../../components/Header/SubNavigation";
import ChartAccordionItem from "../../components/Charts/ChartAccordionItem";
import ChartLegend from "../../components/Charts/ChartLegend";
import { useContext, useEffect, useState } from "react";
import UserContext from "../../store/user-context";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { sendApiRequest } from "../../services/Base/base-service";
import { buildMonthlyData } from "../../services/helpers";
import { Alert, Spinner } from "design-react-kit";
import secureLocalStorage from "react-secure-storage";

const StatisticsDetails = () => {
  const [statisticsData, setStatisticsData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [year, setYear] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (userContext.selectedClientFiscalCode !== null) {
      const yearFromStorage = secureLocalStorage.getItem("year");
      getStatisticsData(yearFromStorage);
      setYear(yearFromStorage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext]);

  const getStatisticsData = (year) => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `Statistics/GetSummary?Year=${year}&FiscalCode=${userContext.selectedClientFiscalCode}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext,
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
        } else {
          const newData = buildMonthlyData(response.data.clients);
          setStatisticsData(newData);
        }
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <SubNavigation page="statisticsDetails" year={year} />
      {error !== null && error.length !== undefined && (
        <Alert color="danger" className="mx-auto">
          {error.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </Alert>
      )}
      {isLoading && (
        <p
          style={{
            height: "50px",
            position: "relative",
            marginBottom: "3rem",
          }}
        >
          <Spinner double active />
        </p>
      )}
      <div className="mt-5">
        {statisticsData !== null &&
          statisticsData !== undefined &&
          statisticsData.filter((item) => item.total.sent > 0).length > 0 && (
            <div className="chart-accordion">
              <div className="details-wrapper" style={{ borderBottom: "none" }}>
                <div className="col-2" />
                <div className="details-bars" style={{ flex: 1 }}>
                  <div className="col-5">
                    <ChartLegend items={[
                      { color: "#0a80f5", label: "Digitale" },
                      { color: "#00994f", label: "Analogico" },
                      { color: "#888888", label: "Non consegnate" },
                    ]} />
                  </div>
                  <div className="col-5 mr-5">
                    <ChartLegend items={[
                      { color: "#00994f", label: "Pagate" },
                      { color: "#888888", label: "Non pagate" },
                    ]} />
                  </div>
                </div>
              </div>
            </div>
          )}
        {statisticsData !== null &&
          statisticsData !== undefined &&
          statisticsData
            .filter((item) => item.total.sent > 0)
            .map((item) => (
              <ChartAccordionItem key={item.month} data={item} year={year} />
            ))}
      </div>
    </>
  );
};

export default StatisticsDetails;
